import BrokenImageIcon from '@mui/icons-material/BrokenImage';
import { Box } from '@mui/material';
import type { BoxProps } from '@mui/material';
import type { FC } from 'react';

interface ImagePlaceholderProps extends BoxProps {
  alt: string;
}

const ImagePlaceholder: FC<ImagePlaceholderProps> = (props) => {
  const { alt, sx, ...other } = props;

  return (
    <Box
      role='img'
      aria-label={`${alt}. Ошибка загрузки`}
      width={'auto'}
      height={'auto'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      sx={{
        color: 'text.secondary',
        backgroundColor: (theme) => theme.palette.background.default,
        ...sx,
      }}
      {...other}>
      <BrokenImageIcon sx={{ fontSize: 80 }} />
    </Box>
  );
};

export default ImagePlaceholder;
